<template>
  <div>
    <b-container class="my-5">
      <b-row class="align-items-center mb-3">
        <b-col cols="2">
          <b-img
            v-bind="mainProps"
            src="../assets/img/icons/Iconos_contacto/1.png"
          ></b-img>
        </b-col>
        <b-col cols="10" class="text">{{datos[0].text}}</b-col>
      </b-row>
      <b-row class="align-items-center mb-3">
        <b-col cols="2">
          <b-img
            v-bind="mainProps"
            src="../assets/img/icons/Iconos_contacto/2.png"
          ></b-img>
        </b-col>
        <b-col cols="10" class="text">{{datos[1].text}}</b-col>
      </b-row>
      <b-row class="align-items-center mb-3">
        <b-col cols="2">
          <b-img
            v-bind="mainProps"
            src="../assets/img/icons/Iconos_contacto/3.png"
          ></b-img>
        </b-col>
        <b-col cols="10" class="text">{{datos[2].text}}</b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  name: "Contact",
  data() {
    return {
        mainProps: { height: 45 },
      datos: [
        {
          id: 0,
          img: "../assets/img/icons/Iconos_contacto/1.png",
          text: "55 5355 2208",
        },
        {
          id: 1,
          img: "../assets/img/icons/Iconos_contacto/2.png",
          text: "contacto@yonekawa.com.mx",
        },
        {
          id: 2,
          img: "../assets/img/icons/Iconos_contacto/3.png",
          text:
            "Platanales #229, Alcaldía Azcapotzalco, Col. Nueva Santa María, C.P. 02800, CDMX",
        },
      ],
    };
  },
};
</script>

<style>
</style>